<!-- Modal content-->
<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'general.export' | translate}}</h4>
    <button type="button" title="close" class="close" (click)="activeModal.close(false)">&times;</button>
</div>
<div class="modal-body">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
             size="medium"
             color="#fff"
             type="line-spin-clockwise-fade"
             [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <form class="w-100" [formGroup]="exportLogForm" (ngSubmit)="exportData()" name="form">
        <div class="row text-break">
            <div class="col-12">
                <p>{{ 'location_updates' | translate }}</p>
                    <label class="radio-inline pt-0 pl-1 pb-0 pr-1">
                        <input type="radio" name="locations" value="1" checked (click)="selectLocations(true)">&nbsp;{{'general.yes' | translate}}
                    </label>
                    <label class="radio-inline pt-0 pl-1 pb-0 pr-1">
                        <input type="radio" name="locations" value="0" (click)="selectLocations(false)">&nbsp;No
                    </label>
            </div>
        </div>
        <div class="row text-break"> 
            <div class="col-12">
                <div *ngIf="!location; else Time"><p>{{ 'export_date' | translate }}</p></div>
                <ng-template #Time><p>{{ 'export_date_time' | translate }}</p></ng-template>
                <div class="row">
                    <div class="col-6">
                            <label for="date" class="page-title mt-1 mr-1 text-dark mb-0">{{'general.date' | translate}}<span class="error">*</span></label><br>
                        <div>
                            <mat-form-field class="mm-10 w-100 fixed-height">
                                <input matInput id="date" formControlName="date" [matDatepicker]="picker" [min]='minDate' [max]='maxDate' readonly
                                [ngClass]="{ 'is-valid': date['valid'], 'is-invalid': date['invalid'] }" >
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                            <ng-container *ngIf="exportLogForm.get('date').invalid && (formSubmitted || exportLogForm.get('date').touched || exportLogForm.get('date').dirty)">
                                <div *ngIf="date['errors']['required']"
                                     class="text-danger align-left">
                                   {{'general.required_field' | translate}}
                               </div>
                           </ng-container>
                        </div>
                    </div>
                    
                    <div *ngIf="location" class="col-6">
                        <label for="hours">{{'hour_range' | translate}}<span class="error">*</span></label>
                            <select id="hours" class="form-control" formControlName="hours" 
                            [ngClass]="{ 'is-valid': hours['valid'], 'is-invalid': hours['invalid'] }">
                                <option class = "text-dark" value="" selected>{{'select_hour' | translate}}</option>
                                <option class = "text-dark" *ngFor="let hour of hourRange | keyvalue" [value]="hour.key">{{hour.value}}</option>
                            </select>
                            <ng-container *ngIf="exportLogForm.get('hours').invalid && (formSubmitted || exportLogForm.get('hours').touched || exportLogForm.get('hours').dirty)">
                                <div *ngIf="hours['errors']['required']"
                                     class="text-danger align-left">
                                   {{'general.required_field' | translate}}
                               </div>
                           </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <hr class="hr-m">
        <div class="row">
            <div class="col-12 text-right">
                <button type="button" title="{{'general.cancel' | translate}}" class="btn btn-red btn-h-red mr-2" (click)="activeModal.close()">
                    {{'general.cancel' | translate}}
                </button>
                <button type="submit" title="{{'general.export' | translate}}" class="btn btn-green btn-h-green">
                    {{'general.export' | translate}}
                </button>
            </div>
        </div>
    </form>
</div>